import { useState, useEffect, useCallback, useRef } from 'react';
import { IdentityService } from '../fetcher/IdentityService.js';

export const PATIENT_DIARY_LAYOUT_SIDEBAR = 'sidebar';
export const PATIENT_DIARY_LAYOUT_TAB = 'tab';

const SETTINGS_KEY = 'patientDiaryLayout';

export const usePatientDiaryLayoutSettings = () => {
  const [layout, setLayoutState] = useState(PATIENT_DIARY_LAYOUT_SIDEBAR);
  const [isLoading, setIsLoading] = useState(true);

  const identityServiceRef = useRef(null);
  if (!identityServiceRef.current) {
    identityServiceRef.current = new IdentityService();
  }

  useEffect(() => {
    identityServiceRef.current.fetchUserSettings()
      .then(allSettings => {
        const saved = allSettings[SETTINGS_KEY];
        if (saved === PATIENT_DIARY_LAYOUT_TAB || saved === PATIENT_DIARY_LAYOUT_SIDEBAR) {
          setLayoutState(saved);
        }
      })
      .catch(err => {
        console.error('Failed to fetch patient diary layout settings:', err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const setLayout = useCallback((newLayout) => {
    setLayoutState(newLayout);
    identityServiceRef.current.updateUserSettings({
      [SETTINGS_KEY]: newLayout
    }).catch(err => {
      console.error('Failed to save patient diary layout settings:', err);
    });
  }, []);

  return {
    layout,
    setLayout,
    isLoading,
    isTabMode: layout === PATIENT_DIARY_LAYOUT_TAB,
    isSidebarMode: layout === PATIENT_DIARY_LAYOUT_SIDEBAR
  };
};
